import { NextPageContext } from "next";

import { StaticApiRouteSpec } from "@every.org/common/src/routes";
import { getNonprofitRouteSpec } from "@every.org/common/src/routes/nonprofit";

import NonprofitsOnboardingIntro from "src/pages/NonprofitOnboardingIntro";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import { validateAndDecodeParam } from "src/utilities/ssr/validateAndDecodeParam";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";
import { serversideStaticQueryApi } from "src/utility/apiClient";

const getNonprofitsOnboardingServerSideProps = async (ctx: NextPageContext) => {
  const slug = validateAndDecodeParam(ctx, "nonprofitSlug").trim();
  const props = { slug };

  try {
    const { nonprofit } = await serversideStaticQueryApi(
      getNonprofitRouteSpec as StaticApiRouteSpec,
      {
        routeTokens: { identifier: slug },
        queryParams: {},
      },
      ctx
    );

    return {
      props: {
        nonprofit,
      },
    };
  } catch (error) {
    if (ctx.res) {
      ctx.res.statusCode = 404;
    }
    return { props: { ...props, notFound: true } };
  }
};

export const getServerSideProps = createGetServerSideProps(
  getNonprofitsOnboardingServerSideProps
);

export default withPropsDeserialization(NonprofitsOnboardingIntro);
